var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"redirection-view"},[(!_vm.isBlocked)?_c('font-awesome-icon',{staticClass:"redirection-view-icon",attrs:{"icon":['fas', 'spinner-third'],"spin":""}}):_c('button',{staticClass:"redirection-view-btn",on:{"click":_vm.handleRefresh}},[_vm._v(" "+_vm._s(_vm.$t('mayday-web.avatar-dropdown.refresh-knowledge'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }